import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import classNames from 'classnames';
import Carousel from 'components/Carousel';
import {
  SITE_PLATFORM_MOBILE,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_WEB_LARGE,
} from 'helpers/BreakpointHelper';
import { fetchCollectionForFooterUpsell } from './FooterUpsellActions';
import Style from './FooterUpsell.module.scss';

const BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: {
    applyInlineBackground: true,
    carouselLimit: 5,
    slidesToScroll: 5,
    allowScrollLock: false,
    showCarouselArrows: true,
    useScrollableDiv: false,
  },
  [SITE_PLATFORM_WEB]: {
    applyInlineBackground: true,
    carouselLimit: 5,
    slidesToScroll: 5,
    allowScrollLock: false,
    showCarouselArrows: true,
    useScrollableDiv: false,
  },
  [SITE_PLATFORM_TABLET]: {
    applyInlineBackground: false,
    carouselLimit: 3,
    slidesToScroll: 3,
    allowScrollLock: true,
    showCarouselArrows: true,
    useScrollableDiv: false,
  },
  [SITE_PLATFORM_MOBILE]: {
    applyInlineBackground: false,
    carouselLimit: 1.75,
    slidesToScroll: 1,
    allowScrollLock: true,
    showCarouselArrows: false,
    useScrollableDiv: true,
  },
};

class FooterUpsell extends Component {
  componentDidMount() {
    const {
      fetchCollectionForFooterUpsell,
      pathkey,
      accessToken,
      screenName,
      deviceId,
    } = this.props;
    fetchCollectionForFooterUpsell(pathkey, accessToken, screenName, deviceId);
  }

  render() {
    const { items, title, subtitle, breakpoint, logo, mobileLogo, processor } = this.props;
    const {
      applyInlineBackground,
      carouselLimit,
      slidesToScroll,
      showCarouselArrows,
      allowScrollLock,
      useScrollableDiv,
    } = BREAKPOINTS[breakpoint];
    const carouselProps = {
      isPosters: true,
      isInfinite: false,
      items,
      slidesToShow: carouselLimit,
      slidesToScroll,
      allowScrollLock,
      roundArrows: true,
      overrideTheme: Style,
      applyInlineBackground,
      showCarouselArrows,
      useScrollableDiv,
      processor,
    };
    if (items.length === 0) return null;
    const brandLogo = breakpoint !== SITE_PLATFORM_MOBILE ? logo : mobileLogo;
    return (
      <div className={classNames(Style.container)}>
        <div className={classNames(Style.screen)}>
          <div className={classNames(Style.outterContainer)}>
            <div className={classNames(Style.header)}>
              <div className={classNames(Style.logo)}>
                <img alt="" src={brandLogo} />
              </div>
              <div className={classNames(Style.title)}>
                <div className={classNames(Style.mainTitle)}>{title}</div>
                <div className={classNames(Style.subtitle)}>{subtitle}</div>
              </div>
            </div>
            <div className={classNames(Style.contents)}>
              <Carousel {...carouselProps} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FooterUpsell.defaultProps = {
  items: [],
  logo: '/static/images/nation-vertical-logo.svg',
  mobileLogo: '/static/images/nation-horizontal-logo.svg',
  title: 'Available on Fox Nation',
  subtitle:
    'Discover Fox Nation Originals and exclusive documentaries. Start watching free for 7 days.',
  breakpoint: '',
  processor: item => ({
    ...item,
    target: '_self',
    link: 'https://nation.foxnews.com/',
    posterImage: _.get(item, 'images.heroPromoImage', null),
    posterAltText: _.get(item, 'images.altText', ''),
  }),
  fetchCollectionForFooterUpsell: () => {},
  pathkey: 'foxNation',
  accessToken: '',
  screenName: '',
  deviceId: '',
};

function mapStateToProps(state) {
  return {
    items: state.footerUpsell.members,
  };
}

FooterUpsell.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})),
  logo: PropTypes.string,
  mobileLogo: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  breakpoint: PropTypes.string,
  processor: PropTypes.func,
  fetchCollectionForFooterUpsell: PropTypes.func,
  pathkey: PropTypes.string,
  accessToken: PropTypes.string,
  screenName: PropTypes.string,
  deviceId: PropTypes.string,
};

export default connect(mapStateToProps, {
  fetchCollectionForFooterUpsell,
})(FooterUpsell);
